import { useId } from 'react';
import { useChains } from '../../data/stores';
import { inputCls } from './classes';

/** Pole „sieć” z podpowiedziami sieci, które już są w bazie. */
export function ChainInput({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const chains = useChains();
  const listId = useId();
  return (
    <>
      <input
        list={listId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="np. Auchan"
        autoComplete="off"
        autoCapitalize="words"
        enterKeyHint="done"
        className={inputCls}
      />
      <datalist id={listId}>{chains?.map((c) => c.name && <option key={c.id} value={c.name} />)}</datalist>
    </>
  );
}
